import RaceInfo from './RaceInfo';

export default RaceInfo;
